var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"we-action",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.text)+" "),(!_vm.text)?_vm._t("text"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }